import React from "react";

export default function RecentWinners({ winners }) {
  if (!winners?.length) return null;
  return (
    <div className="bg-slate-800 rounded-xl p-4">
      <div className="font-bold mb-2">Recent Winners</div>
      <ul className="space-y-1">
        {winners.map((w, i) => (
          <li key={i} className="flex items-center gap-2 text-sm">
            <span className="rounded-full bg-yellow-300 text-black font-bold px-2">
              {w.number}
            </span>
            <span>{w.username}</span>
            <span className="text-green-400 font-bold">${w.amount}</span>
            <span className="text-xs text-gray-400">{w.time}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
